import * as _ from 'lodash';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { Formatter } from 'slickgrid';

export interface DateTimeFormatterOptions {
  format?: string;
}

export function datetime<T>(opts: DateTimeFormatterOptions): Formatter<T> {
  const fmt = opts.format || 'yyyy-MM-dd HH:mm';

  return function datetimeFormatter(row, cell, value, columnDef, data) {
    if (_.isString(value)) {
      value = parseISO(value);
    }
    return value ? format(value, fmt) : '';
  };
}
